import { Component, OnInit } from '@angular/core';
import { PagesContentService, PageContent } from '../../services/pages-content.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-hopesanddreams',
  templateUrl: './hopesanddreams.component.html',
  styleUrl: './hopesanddreams.component.scss'
})
export class HopesanddreamsComponent implements OnInit {
 // Holds raw content from the API
  content: string = '';
  // Safe HTML version for binding to innerHTML in the template
  safeContent: SafeHtml = '';
  // An error message in case the API call fails or no content is found
  errorMessage: string = '';

  constructor(
    private pagesContentService: PagesContentService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.loadContent();
  }

  // Load content for the 'travel' component from the database.
  loadContent(): void {
    this.pagesContentService.getContent('hopesanddreams').subscribe(
      res => {
        if (res.success && res.data) {
          this.content = res.data.content;
          // Sanitize HTML content to safely bind with innerHTML
          this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
        } else {
          this.errorMessage = 'No content found for Hopes and Dreams.';
        }
      },
      error => {
        this.errorMessage = 'Error retrieving content.';
      }
    );
  }

}

